/* tslint:disable */
/* eslint-disable */
/**
 * Structure API V3
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BoltConnectionCreateDto
 */
export interface BoltConnectionCreateDto {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionCreateDto
     */
    'name': string | null;
    /**
     * 
     * @type {BoltConstraintsDto}
     * @memberof BoltConnectionCreateDto
     */
    'boltConstraints'?: BoltConstraintsDto;
    /**
     * 
     * @type {TreeNodeNewLocationDto}
     * @memberof BoltConnectionCreateDto
     */
    'treeNodeLocation'?: TreeNodeNewLocationDto;
}
/**
 * 
 * @export
 * @interface BoltConnectionReadDto
 */
export interface BoltConnectionReadDto {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'aggregateId': string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'archivedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BoltConnectionReadDto
     */
    'isArchived': boolean;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'organizationId': string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'createdBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'archivedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'orderKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'ancestorNamePath': string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'ancestorIdPath': string | null;
    /**
     * 
     * @type {Array<TreeNodeAncestorReadDto>}
     * @memberof BoltConnectionReadDto
     */
    'ancestors': Array<TreeNodeAncestorReadDto> | null;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'rootId': string | null;
    /**
     * 
     * @type {TreeNodeSourceType}
     * @memberof BoltConnectionReadDto
     */
    'sourceType': TreeNodeSourceType;
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionReadDto
     */
    'parentId'?: string | null;
    /**
     * 
     * @type {BoltConstraintsDto}
     * @memberof BoltConnectionReadDto
     */
    'boltConstraints': BoltConstraintsDto;
}


/**
 * 
 * @export
 * @interface BoltConnectionReadDtoPageDto
 */
export interface BoltConnectionReadDtoPageDto {
    /**
     * 
     * @type {Array<BoltConnectionReadDto>}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'items': Array<BoltConnectionReadDto>;
    /**
     * 
     * @type {number}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BoltConnectionReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface BoltConnectionUpdateDto
 */
export interface BoltConnectionUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionUpdateDto
     */
    'name': string | null;
    /**
     * 
     * @type {BoltConstraintsDto}
     * @memberof BoltConnectionUpdateDto
     */
    'boltConstraints'?: BoltConstraintsDto;
    /**
     * 
     * @type {TreeNodeNewLocationDto}
     * @memberof BoltConnectionUpdateDto
     */
    'treeNodeLocation'?: TreeNodeNewLocationDto;
}
/**
 * 
 * @export
 * @interface BoltConnectionWriteResponse
 */
export interface BoltConnectionWriteResponse {
    /**
     * 
     * @type {Array<TreeNodeReadDto>}
     * @memberof BoltConnectionWriteResponse
     */
    'addedOrModified'?: Array<TreeNodeReadDto> | null;
    /**
     * 
     * @type {Array<TreeNodeReadDto>}
     * @memberof BoltConnectionWriteResponse
     */
    'removed'?: Array<TreeNodeReadDto> | null;
    /**
     * 
     * @type {BoltConnectionReadDto}
     * @memberof BoltConnectionWriteResponse
     */
    'model': BoltConnectionReadDto;
}
/**
 * 
 * @export
 * @interface BoltConstraintsDto
 */
export interface BoltConstraintsDto {
    /**
     * 
     * @type {number}
     * @memberof BoltConstraintsDto
     */
    'pretensionForceMaxKn'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BoltConstraintsDto
     */
    'pretensionForceMinKn'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BoltConstraintsDto
     */
    'characteristicPretensionForceMinKn'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BoltConstraintsDto
     */
    'expectedNominalLengthMm'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BoltConstraintsDto
     */
    'springConstantKnMm'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BoltConstraintsDto
     */
    'expectedNumberOfBolts'?: number | null;
    /**
     * 
     * @type {BoltType}
     * @memberof BoltConstraintsDto
     */
    'expectedBoltType'?: BoltType;
    /**
     * 
     * @type {Material}
     * @memberof BoltConstraintsDto
     */
    'expectedBoltMaterial'?: Material;
    /**
     * 
     * @type {BoltDiameter}
     * @memberof BoltConstraintsDto
     */
    'expectedBoltSize'?: BoltDiameter;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BoltDiameter = {
    None: 'none',
    M12: 'm12',
    M16: 'm16',
    M20: 'm20',
    M24: 'm24',
    M30: 'm30',
    M36: 'm36',
    M42: 'm42',
    M48: 'm48',
    M56: 'm56',
    M64: 'm64',
    M72: 'm72',
    M14: 'm14',
    M18: 'm18',
    M22: 'm22',
    M27: 'm27',
    M33: 'm33',
    M39: 'm39',
    M45: 'm45',
    M52: 'm52',
    M60: 'm60',
    M80: 'm80',
    M90: 'm90',
    M100: 'm100'
} as const;

export type BoltDiameter = typeof BoltDiameter[keyof typeof BoltDiameter];


/**
 * 
 * @export
 * @enum {string}
 */

export const BoltType = {
    None: 'none',
    Hv: 'hv',
    IsO4014: 'isO4014',
    ThreadRod: 'threadRod'
} as const;

export type BoltType = typeof BoltType[keyof typeof BoltType];


/**
 * 
 * @export
 * @enum {string}
 */

export const Material = {
    None: 'none',
    Gr88: 'gr8_8',
    Gr109: 'gr10_9',
    Gr129: 'gr12_9'
} as const;

export type Material = typeof Material[keyof typeof Material];


/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface ProjectCreateDto
 */
export interface ProjectCreateDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectCreateDto
     */
    'name': string | null;
    /**
     * 
     * @type {TreeNodeNewLocationDto}
     * @memberof ProjectCreateDto
     */
    'treeNodeLocation'?: TreeNodeNewLocationDto;
}
/**
 * 
 * @export
 * @interface ProjectReadDto
 */
export interface ProjectReadDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'aggregateId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'archivedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectReadDto
     */
    'isArchived': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'organizationId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'createdBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'archivedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'orderKey': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'ancestorNamePath': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'ancestorIdPath': string | null;
    /**
     * 
     * @type {Array<TreeNodeAncestorReadDto>}
     * @memberof ProjectReadDto
     */
    'ancestors': Array<TreeNodeAncestorReadDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'rootId': string | null;
    /**
     * 
     * @type {TreeNodeSourceType}
     * @memberof ProjectReadDto
     */
    'sourceType': TreeNodeSourceType;
    /**
     * 
     * @type {string}
     * @memberof ProjectReadDto
     */
    'parentId'?: string | null;
}


/**
 * 
 * @export
 * @interface ProjectReadDtoPageDto
 */
export interface ProjectReadDtoPageDto {
    /**
     * 
     * @type {Array<ProjectReadDto>}
     * @memberof ProjectReadDtoPageDto
     */
    'items': Array<ProjectReadDto>;
    /**
     * 
     * @type {number}
     * @memberof ProjectReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface ProjectUpdateDto
 */
export interface ProjectUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectUpdateDto
     */
    'name': string | null;
    /**
     * 
     * @type {TreeNodeNewLocationDto}
     * @memberof ProjectUpdateDto
     */
    'treeNodeLocation'?: TreeNodeNewLocationDto;
}
/**
 * 
 * @export
 * @interface ProjectWriteResponse
 */
export interface ProjectWriteResponse {
    /**
     * 
     * @type {Array<TreeNodeReadDto>}
     * @memberof ProjectWriteResponse
     */
    'addedOrModified'?: Array<TreeNodeReadDto> | null;
    /**
     * 
     * @type {Array<TreeNodeReadDto>}
     * @memberof ProjectWriteResponse
     */
    'removed'?: Array<TreeNodeReadDto> | null;
    /**
     * 
     * @type {ProjectReadDto}
     * @memberof ProjectWriteResponse
     */
    'model': ProjectReadDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ServiceStatus = {
    Active: 'active',
    Overdue: 'overdue',
    Done: 'done'
} as const;

export type ServiceStatus = typeof ServiceStatus[keyof typeof ServiceStatus];


/**
 * 
 * @export
 * @interface ServiceWindowBoltConnectionReadDto
 */
export interface ServiceWindowBoltConnectionReadDto {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowBoltConnectionReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowBoltConnectionReadDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowBoltConnectionReadDto
     */
    'path': string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceWindowBoltConnectionReadDto
     */
    'isArchived': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceWindowBoltConnectionReadDto
     */
    'isErased': boolean;
}
/**
 * 
 * @export
 * @interface ServiceWindowCompleteDto
 */
export interface ServiceWindowCompleteDto {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowCompleteDto
     */
    'occurrenceId': string;
}
/**
 * 
 * @export
 * @interface ServiceWindowCompletionReadDto
 */
export interface ServiceWindowCompletionReadDto {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowCompletionReadDto
     */
    'occurrenceId': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowCompletionReadDto
     */
    'scheduledFor': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowCompletionReadDto
     */
    'completedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowCompletionReadDto
     */
    'completedBy': string;
}
/**
 * 
 * @export
 * @interface ServiceWindowCreateDto
 */
export interface ServiceWindowCreateDto {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowCreateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowCreateDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowCreateDto
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowCreateDto
     */
    'repeatDays': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceWindowCreateDto
     */
    'boltConnectionIds': Array<string>;
}
/**
 * 
 * @export
 * @interface ServiceWindowOccurrenceReadDto
 */
export interface ServiceWindowOccurrenceReadDto {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowOccurrenceReadDto
     */
    'occurrenceId': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowOccurrenceReadDto
     */
    'scheduledFor': string;
}
/**
 * 
 * @export
 * @interface ServiceWindowReadDto
 */
export interface ServiceWindowReadDto {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowReadDto
     */
    'aggregateId': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowReadDto
     */
    'organizationId': string;
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowReadDto
     */
    'revision': number;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowReadDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowReadDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowReadDto
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowReadDto
     */
    'repeatDays': number;
    /**
     * 
     * @type {ServiceWindowOccurrenceReadDto}
     * @memberof ServiceWindowReadDto
     */
    'nextService'?: ServiceWindowOccurrenceReadDto | null;
    /**
     * 
     * @type {ServiceStatus}
     * @memberof ServiceWindowReadDto
     */
    'status': ServiceStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceWindowReadDto
     */
    'isTerminal': boolean;
    /**
     * 
     * @type {ServiceWindowCompletionReadDto}
     * @memberof ServiceWindowReadDto
     */
    'lastCompletion'?: ServiceWindowCompletionReadDto | null;
    /**
     * 
     * @type {Array<ServiceWindowBoltConnectionReadDto>}
     * @memberof ServiceWindowReadDto
     */
    'boltConnections': Array<ServiceWindowBoltConnectionReadDto>;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowReadDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowReadDto
     */
    'lastUpdatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface ServiceWindowReadDtoPageDto
 */
export interface ServiceWindowReadDtoPageDto {
    /**
     * 
     * @type {Array<ServiceWindowReadDto>}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'items': Array<ServiceWindowReadDto>;
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceWindowReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface ServiceWindowUpdateDto
 */
export interface ServiceWindowUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowUpdateDto
     */
    'revision': number;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowUpdateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowUpdateDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowUpdateDto
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof ServiceWindowUpdateDto
     */
    'repeatDays': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceWindowUpdateDto
     */
    'boltConnectionIds': Array<string>;
}
/**
 * 
 * @export
 * @interface TreeNodeAncestorReadDto
 */
export interface TreeNodeAncestorReadDto {
    /**
     * 
     * @type {string}
     * @memberof TreeNodeAncestorReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TreeNodeAncestorReadDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TreeNodeNewLocationDto
 */
export interface TreeNodeNewLocationDto {
    /**
     * 
     * @type {string}
     * @memberof TreeNodeNewLocationDto
     */
    'parentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TreeNodeNewLocationDto
     */
    'placeAfterOrderKey'?: string | null;
}
/**
 * 
 * @export
 * @interface TreeNodeReadDto
 */
export interface TreeNodeReadDto {
    /**
     * 
     * @type {string}
     * @memberof TreeNodeReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TreeNodeReadDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TreeNodeReadDto
     */
    'orderKey': string;
    /**
     * 
     * @type {string}
     * @memberof TreeNodeReadDto
     */
    'ancestorNamePath': string;
    /**
     * 
     * @type {string}
     * @memberof TreeNodeReadDto
     */
    'ancestorIdPath': string;
    /**
     * 
     * @type {boolean}
     * @memberof TreeNodeReadDto
     */
    'archived': boolean;
    /**
     * 
     * @type {Array<TreeNodeAncestorReadDto>}
     * @memberof TreeNodeReadDto
     */
    'ancestors': Array<TreeNodeAncestorReadDto>;
    /**
     * 
     * @type {string}
     * @memberof TreeNodeReadDto
     */
    'rootId': string;
    /**
     * 
     * @type {TreeNodeSourceType}
     * @memberof TreeNodeReadDto
     */
    'sourceType': TreeNodeSourceType;
    /**
     * 
     * @type {string}
     * @memberof TreeNodeReadDto
     */
    'parentId'?: string | null;
    /**
     * 
     * @type {Array<TreeNodeReadDto>}
     * @memberof TreeNodeReadDto
     */
    'children': Array<TreeNodeReadDto>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TreeNodeSourceType = {
    BoltConnection: 'boltConnection',
    Project: 'project'
} as const;

export type TreeNodeSourceType = typeof TreeNodeSourceType[keyof typeof TreeNodeSourceType];



/**
 * BoltConnectionApi - axios parameter creator
 * @export
 */
export const BoltConnectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveBoltConnectionV3: async (boltConnectionId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('archiveBoltConnectionV3', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('archiveBoltConnectionV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/bolt-connection/{boltConnectionId}/archive`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} tenantId 
         * @param {BoltConnectionCreateDto} [boltConnectionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoltConnectionV3: async (tenantId: string, boltConnectionCreateDto?: BoltConnectionCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createBoltConnectionV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/bolt-connection`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boltConnectionCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBoltConnectionV3: async (boltConnectionId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('duplicateBoltConnectionV3', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('duplicateBoltConnectionV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/bolt-connection/{boltConnectionId}/duplicate`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseBoltConnectionV3: async (boltConnectionId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('eraseBoltConnectionV3', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('eraseBoltConnectionV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/bolt-connection/{boltConnectionId}`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBoltConnectionsV3: async (tenantId: string, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getAllBoltConnectionsV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/bolt-connection`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltConnectionQrImageV3: async (boltConnectionId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('getBoltConnectionQrImageV3', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBoltConnectionQrImageV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/bolt-connection/{boltConnectionId}/qr-code`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltConnectionV3: async (boltConnectionId: string, tenantId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('getBoltConnectionV3', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBoltConnectionV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/bolt-connection/{boltConnectionId}`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {TreeNodeNewLocationDto} [treeNodeNewLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveBoltConnectionV3: async (boltConnectionId: string, tenantId: string, treeNodeNewLocationDto?: TreeNodeNewLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('moveBoltConnectionV3', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('moveBoltConnectionV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/bolt-connection/{boltConnectionId}/move`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(treeNodeNewLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBoltConnectionV3: async (boltConnectionId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('restoreBoltConnectionV3', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('restoreBoltConnectionV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/bolt-connection/{boltConnectionId}/restore`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {BoltConnectionUpdateDto} [boltConnectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBoltConnectionV3: async (boltConnectionId: string, tenantId: string, boltConnectionUpdateDto?: BoltConnectionUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('updateBoltConnectionV3', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateBoltConnectionV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/bolt-connection/{boltConnectionId}`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boltConnectionUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BoltConnectionApi - functional programming interface
 * @export
 */
export const BoltConnectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BoltConnectionApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveBoltConnectionV3(boltConnectionId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltConnectionWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveBoltConnectionV3(boltConnectionId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltConnectionApi.archiveBoltConnectionV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} tenantId 
         * @param {BoltConnectionCreateDto} [boltConnectionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBoltConnectionV3(tenantId: string, boltConnectionCreateDto?: BoltConnectionCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltConnectionWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBoltConnectionV3(tenantId, boltConnectionCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltConnectionApi.createBoltConnectionV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateBoltConnectionV3(boltConnectionId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltConnectionWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateBoltConnectionV3(boltConnectionId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltConnectionApi.duplicateBoltConnectionV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eraseBoltConnectionV3(boltConnectionId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltConnectionWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eraseBoltConnectionV3(boltConnectionId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltConnectionApi.eraseBoltConnectionV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBoltConnectionsV3(tenantId: string, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltConnectionReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBoltConnectionsV3(tenantId, skip, take, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltConnectionApi.getAllBoltConnectionsV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoltConnectionQrImageV3(boltConnectionId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoltConnectionQrImageV3(boltConnectionId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltConnectionApi.getBoltConnectionQrImageV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoltConnectionV3(boltConnectionId: string, tenantId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltConnectionReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoltConnectionV3(boltConnectionId, tenantId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltConnectionApi.getBoltConnectionV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {TreeNodeNewLocationDto} [treeNodeNewLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveBoltConnectionV3(boltConnectionId: string, tenantId: string, treeNodeNewLocationDto?: TreeNodeNewLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltConnectionWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveBoltConnectionV3(boltConnectionId, tenantId, treeNodeNewLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltConnectionApi.moveBoltConnectionV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreBoltConnectionV3(boltConnectionId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltConnectionWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreBoltConnectionV3(boltConnectionId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltConnectionApi.restoreBoltConnectionV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {BoltConnectionUpdateDto} [boltConnectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBoltConnectionV3(boltConnectionId: string, tenantId: string, boltConnectionUpdateDto?: BoltConnectionUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltConnectionWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBoltConnectionV3(boltConnectionId, tenantId, boltConnectionUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltConnectionApi.updateBoltConnectionV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BoltConnectionApi - factory interface
 * @export
 */
export const BoltConnectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BoltConnectionApiFp(configuration)
    return {
        /**
         * Required permissions: `structure:write`
         * @param {BoltConnectionApiArchiveBoltConnectionV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveBoltConnectionV3(requestParameters: BoltConnectionApiArchiveBoltConnectionV3Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltConnectionWriteResponse> {
            return localVarFp.archiveBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {BoltConnectionApiCreateBoltConnectionV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoltConnectionV3(requestParameters: BoltConnectionApiCreateBoltConnectionV3Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltConnectionWriteResponse> {
            return localVarFp.createBoltConnectionV3(requestParameters.tenantId, requestParameters.boltConnectionCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {BoltConnectionApiDuplicateBoltConnectionV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBoltConnectionV3(requestParameters: BoltConnectionApiDuplicateBoltConnectionV3Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltConnectionWriteResponse> {
            return localVarFp.duplicateBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {BoltConnectionApiEraseBoltConnectionV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseBoltConnectionV3(requestParameters: BoltConnectionApiEraseBoltConnectionV3Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltConnectionWriteResponse> {
            return localVarFp.eraseBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {BoltConnectionApiGetAllBoltConnectionsV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBoltConnectionsV3(requestParameters: BoltConnectionApiGetAllBoltConnectionsV3Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltConnectionReadDtoPageDto> {
            return localVarFp.getAllBoltConnectionsV3(requestParameters.tenantId, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {BoltConnectionApiGetBoltConnectionQrImageV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltConnectionQrImageV3(requestParameters: BoltConnectionApiGetBoltConnectionQrImageV3Request, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getBoltConnectionQrImageV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {BoltConnectionApiGetBoltConnectionV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltConnectionV3(requestParameters: BoltConnectionApiGetBoltConnectionV3Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltConnectionReadDto> {
            return localVarFp.getBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {BoltConnectionApiMoveBoltConnectionV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveBoltConnectionV3(requestParameters: BoltConnectionApiMoveBoltConnectionV3Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltConnectionWriteResponse> {
            return localVarFp.moveBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.treeNodeNewLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {BoltConnectionApiRestoreBoltConnectionV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBoltConnectionV3(requestParameters: BoltConnectionApiRestoreBoltConnectionV3Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltConnectionWriteResponse> {
            return localVarFp.restoreBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {BoltConnectionApiUpdateBoltConnectionV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBoltConnectionV3(requestParameters: BoltConnectionApiUpdateBoltConnectionV3Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltConnectionWriteResponse> {
            return localVarFp.updateBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.boltConnectionUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for archiveBoltConnectionV3 operation in BoltConnectionApi.
 * @export
 * @interface BoltConnectionApiArchiveBoltConnectionV3Request
 */
export interface BoltConnectionApiArchiveBoltConnectionV3Request {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiArchiveBoltConnectionV3
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiArchiveBoltConnectionV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for createBoltConnectionV3 operation in BoltConnectionApi.
 * @export
 * @interface BoltConnectionApiCreateBoltConnectionV3Request
 */
export interface BoltConnectionApiCreateBoltConnectionV3Request {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiCreateBoltConnectionV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {BoltConnectionCreateDto}
     * @memberof BoltConnectionApiCreateBoltConnectionV3
     */
    readonly boltConnectionCreateDto?: BoltConnectionCreateDto
}

/**
 * Request parameters for duplicateBoltConnectionV3 operation in BoltConnectionApi.
 * @export
 * @interface BoltConnectionApiDuplicateBoltConnectionV3Request
 */
export interface BoltConnectionApiDuplicateBoltConnectionV3Request {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiDuplicateBoltConnectionV3
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiDuplicateBoltConnectionV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for eraseBoltConnectionV3 operation in BoltConnectionApi.
 * @export
 * @interface BoltConnectionApiEraseBoltConnectionV3Request
 */
export interface BoltConnectionApiEraseBoltConnectionV3Request {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiEraseBoltConnectionV3
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiEraseBoltConnectionV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for getAllBoltConnectionsV3 operation in BoltConnectionApi.
 * @export
 * @interface BoltConnectionApiGetAllBoltConnectionsV3Request
 */
export interface BoltConnectionApiGetAllBoltConnectionsV3Request {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {number}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetAllBoltConnectionsV3
     */
    readonly archivedAtEnd?: string
}

/**
 * Request parameters for getBoltConnectionQrImageV3 operation in BoltConnectionApi.
 * @export
 * @interface BoltConnectionApiGetBoltConnectionQrImageV3Request
 */
export interface BoltConnectionApiGetBoltConnectionQrImageV3Request {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetBoltConnectionQrImageV3
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetBoltConnectionQrImageV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for getBoltConnectionV3 operation in BoltConnectionApi.
 * @export
 * @interface BoltConnectionApiGetBoltConnectionV3Request
 */
export interface BoltConnectionApiGetBoltConnectionV3Request {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetBoltConnectionV3
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiGetBoltConnectionV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltConnectionApiGetBoltConnectionV3
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for moveBoltConnectionV3 operation in BoltConnectionApi.
 * @export
 * @interface BoltConnectionApiMoveBoltConnectionV3Request
 */
export interface BoltConnectionApiMoveBoltConnectionV3Request {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiMoveBoltConnectionV3
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiMoveBoltConnectionV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {TreeNodeNewLocationDto}
     * @memberof BoltConnectionApiMoveBoltConnectionV3
     */
    readonly treeNodeNewLocationDto?: TreeNodeNewLocationDto
}

/**
 * Request parameters for restoreBoltConnectionV3 operation in BoltConnectionApi.
 * @export
 * @interface BoltConnectionApiRestoreBoltConnectionV3Request
 */
export interface BoltConnectionApiRestoreBoltConnectionV3Request {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiRestoreBoltConnectionV3
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiRestoreBoltConnectionV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for updateBoltConnectionV3 operation in BoltConnectionApi.
 * @export
 * @interface BoltConnectionApiUpdateBoltConnectionV3Request
 */
export interface BoltConnectionApiUpdateBoltConnectionV3Request {
    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiUpdateBoltConnectionV3
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltConnectionApiUpdateBoltConnectionV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {BoltConnectionUpdateDto}
     * @memberof BoltConnectionApiUpdateBoltConnectionV3
     */
    readonly boltConnectionUpdateDto?: BoltConnectionUpdateDto
}

/**
 * BoltConnectionApi - object-oriented interface
 * @export
 * @class BoltConnectionApi
 * @extends {BaseAPI}
 */
export class BoltConnectionApi extends BaseAPI {
    /**
     * Required permissions: `structure:write`
     * @param {BoltConnectionApiArchiveBoltConnectionV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltConnectionApi
     */
    public archiveBoltConnectionV3(requestParameters: BoltConnectionApiArchiveBoltConnectionV3Request, options?: RawAxiosRequestConfig) {
        return BoltConnectionApiFp(this.configuration).archiveBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {BoltConnectionApiCreateBoltConnectionV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltConnectionApi
     */
    public createBoltConnectionV3(requestParameters: BoltConnectionApiCreateBoltConnectionV3Request, options?: RawAxiosRequestConfig) {
        return BoltConnectionApiFp(this.configuration).createBoltConnectionV3(requestParameters.tenantId, requestParameters.boltConnectionCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {BoltConnectionApiDuplicateBoltConnectionV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltConnectionApi
     */
    public duplicateBoltConnectionV3(requestParameters: BoltConnectionApiDuplicateBoltConnectionV3Request, options?: RawAxiosRequestConfig) {
        return BoltConnectionApiFp(this.configuration).duplicateBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {BoltConnectionApiEraseBoltConnectionV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltConnectionApi
     */
    public eraseBoltConnectionV3(requestParameters: BoltConnectionApiEraseBoltConnectionV3Request, options?: RawAxiosRequestConfig) {
        return BoltConnectionApiFp(this.configuration).eraseBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`structure:read` OR `device-app:*`]
     * @param {BoltConnectionApiGetAllBoltConnectionsV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltConnectionApi
     */
    public getAllBoltConnectionsV3(requestParameters: BoltConnectionApiGetAllBoltConnectionsV3Request, options?: RawAxiosRequestConfig) {
        return BoltConnectionApiFp(this.configuration).getAllBoltConnectionsV3(requestParameters.tenantId, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`structure:read` OR `device-app:*`]
     * @param {BoltConnectionApiGetBoltConnectionQrImageV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltConnectionApi
     */
    public getBoltConnectionQrImageV3(requestParameters: BoltConnectionApiGetBoltConnectionQrImageV3Request, options?: RawAxiosRequestConfig) {
        return BoltConnectionApiFp(this.configuration).getBoltConnectionQrImageV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`structure:read` OR `device-app:*`]
     * @param {BoltConnectionApiGetBoltConnectionV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltConnectionApi
     */
    public getBoltConnectionV3(requestParameters: BoltConnectionApiGetBoltConnectionV3Request, options?: RawAxiosRequestConfig) {
        return BoltConnectionApiFp(this.configuration).getBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {BoltConnectionApiMoveBoltConnectionV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltConnectionApi
     */
    public moveBoltConnectionV3(requestParameters: BoltConnectionApiMoveBoltConnectionV3Request, options?: RawAxiosRequestConfig) {
        return BoltConnectionApiFp(this.configuration).moveBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.treeNodeNewLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {BoltConnectionApiRestoreBoltConnectionV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltConnectionApi
     */
    public restoreBoltConnectionV3(requestParameters: BoltConnectionApiRestoreBoltConnectionV3Request, options?: RawAxiosRequestConfig) {
        return BoltConnectionApiFp(this.configuration).restoreBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {BoltConnectionApiUpdateBoltConnectionV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltConnectionApi
     */
    public updateBoltConnectionV3(requestParameters: BoltConnectionApiUpdateBoltConnectionV3Request, options?: RawAxiosRequestConfig) {
        return BoltConnectionApiFp(this.configuration).updateBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.boltConnectionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectApi - axios parameter creator
 * @export
 */
export const ProjectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProjectV3: async (projectId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('archiveProjectV3', 'projectId', projectId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('archiveProjectV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/project/{projectId}/archive`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} tenantId 
         * @param {ProjectCreateDto} [projectCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectV3: async (tenantId: string, projectCreateDto?: ProjectCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createProjectV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/project`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateProjectV3: async (projectId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('duplicateProjectV3', 'projectId', projectId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('duplicateProjectV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/project/{projectId}/duplicate`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseProjectV3: async (projectId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('eraseProjectV3', 'projectId', projectId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('eraseProjectV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/project/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsV3: async (tenantId: string, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getAllProjectsV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/project`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectQrImageV3: async (projectId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectQrImageV3', 'projectId', projectId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getProjectQrImageV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/project/{projectId}/qr-code`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectV3: async (projectId: string, tenantId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectV3', 'projectId', projectId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getProjectV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/project/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {TreeNodeNewLocationDto} [treeNodeNewLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveProjectV3: async (projectId: string, tenantId: string, treeNodeNewLocationDto?: TreeNodeNewLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('moveProjectV3', 'projectId', projectId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('moveProjectV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/project/{projectId}/move`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(treeNodeNewLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreProjectV3: async (projectId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('restoreProjectV3', 'projectId', projectId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('restoreProjectV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/project/{projectId}/restore`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {ProjectUpdateDto} [projectUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectV3: async (projectId: string, tenantId: string, projectUpdateDto?: ProjectUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateProjectV3', 'projectId', projectId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateProjectV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/project/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectApi - functional programming interface
 * @export
 */
export const ProjectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveProjectV3(projectId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveProjectV3(projectId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.archiveProjectV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} tenantId 
         * @param {ProjectCreateDto} [projectCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectV3(tenantId: string, projectCreateDto?: ProjectCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectV3(tenantId, projectCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.createProjectV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateProjectV3(projectId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateProjectV3(projectId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.duplicateProjectV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eraseProjectV3(projectId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eraseProjectV3(projectId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.eraseProjectV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProjectsV3(tenantId: string, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectsV3(tenantId, skip, take, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.getAllProjectsV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectQrImageV3(projectId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectQrImageV3(projectId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.getProjectQrImageV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectV3(projectId: string, tenantId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectV3(projectId, tenantId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.getProjectV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {TreeNodeNewLocationDto} [treeNodeNewLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveProjectV3(projectId: string, tenantId: string, treeNodeNewLocationDto?: TreeNodeNewLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveProjectV3(projectId, tenantId, treeNodeNewLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.moveProjectV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreProjectV3(projectId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreProjectV3(projectId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.restoreProjectV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {ProjectUpdateDto} [projectUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectV3(projectId: string, tenantId: string, projectUpdateDto?: ProjectUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectV3(projectId, tenantId, projectUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.updateProjectV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectApi - factory interface
 * @export
 */
export const ProjectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectApiFp(configuration)
    return {
        /**
         * Required permissions: `structure:write`
         * @param {ProjectApiArchiveProjectV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveProjectV3(requestParameters: ProjectApiArchiveProjectV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ProjectWriteResponse> {
            return localVarFp.archiveProjectV3(requestParameters.projectId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {ProjectApiCreateProjectV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectV3(requestParameters: ProjectApiCreateProjectV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ProjectWriteResponse> {
            return localVarFp.createProjectV3(requestParameters.tenantId, requestParameters.projectCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {ProjectApiDuplicateProjectV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateProjectV3(requestParameters: ProjectApiDuplicateProjectV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ProjectWriteResponse> {
            return localVarFp.duplicateProjectV3(requestParameters.projectId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {ProjectApiEraseProjectV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseProjectV3(requestParameters: ProjectApiEraseProjectV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ProjectWriteResponse> {
            return localVarFp.eraseProjectV3(requestParameters.projectId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {ProjectApiGetAllProjectsV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsV3(requestParameters: ProjectApiGetAllProjectsV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ProjectReadDtoPageDto> {
            return localVarFp.getAllProjectsV3(requestParameters.tenantId, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {ProjectApiGetProjectQrImageV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectQrImageV3(requestParameters: ProjectApiGetProjectQrImageV3Request, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getProjectQrImageV3(requestParameters.projectId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {ProjectApiGetProjectV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectV3(requestParameters: ProjectApiGetProjectV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ProjectReadDto> {
            return localVarFp.getProjectV3(requestParameters.projectId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {ProjectApiMoveProjectV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveProjectV3(requestParameters: ProjectApiMoveProjectV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ProjectWriteResponse> {
            return localVarFp.moveProjectV3(requestParameters.projectId, requestParameters.tenantId, requestParameters.treeNodeNewLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {ProjectApiRestoreProjectV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreProjectV3(requestParameters: ProjectApiRestoreProjectV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ProjectWriteResponse> {
            return localVarFp.restoreProjectV3(requestParameters.projectId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {ProjectApiUpdateProjectV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectV3(requestParameters: ProjectApiUpdateProjectV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ProjectWriteResponse> {
            return localVarFp.updateProjectV3(requestParameters.projectId, requestParameters.tenantId, requestParameters.projectUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for archiveProjectV3 operation in ProjectApi.
 * @export
 * @interface ProjectApiArchiveProjectV3Request
 */
export interface ProjectApiArchiveProjectV3Request {
    /**
     * 
     * @type {string}
     * @memberof ProjectApiArchiveProjectV3
     */
    readonly projectId: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiArchiveProjectV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for createProjectV3 operation in ProjectApi.
 * @export
 * @interface ProjectApiCreateProjectV3Request
 */
export interface ProjectApiCreateProjectV3Request {
    /**
     * 
     * @type {string}
     * @memberof ProjectApiCreateProjectV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {ProjectCreateDto}
     * @memberof ProjectApiCreateProjectV3
     */
    readonly projectCreateDto?: ProjectCreateDto
}

/**
 * Request parameters for duplicateProjectV3 operation in ProjectApi.
 * @export
 * @interface ProjectApiDuplicateProjectV3Request
 */
export interface ProjectApiDuplicateProjectV3Request {
    /**
     * 
     * @type {string}
     * @memberof ProjectApiDuplicateProjectV3
     */
    readonly projectId: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiDuplicateProjectV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for eraseProjectV3 operation in ProjectApi.
 * @export
 * @interface ProjectApiEraseProjectV3Request
 */
export interface ProjectApiEraseProjectV3Request {
    /**
     * 
     * @type {string}
     * @memberof ProjectApiEraseProjectV3
     */
    readonly projectId: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiEraseProjectV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for getAllProjectsV3 operation in ProjectApi.
 * @export
 * @interface ProjectApiGetAllProjectsV3Request
 */
export interface ProjectApiGetAllProjectsV3Request {
    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {number}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetAllProjectsV3
     */
    readonly archivedAtEnd?: string
}

/**
 * Request parameters for getProjectQrImageV3 operation in ProjectApi.
 * @export
 * @interface ProjectApiGetProjectQrImageV3Request
 */
export interface ProjectApiGetProjectQrImageV3Request {
    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetProjectQrImageV3
     */
    readonly projectId: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetProjectQrImageV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for getProjectV3 operation in ProjectApi.
 * @export
 * @interface ProjectApiGetProjectV3Request
 */
export interface ProjectApiGetProjectV3Request {
    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetProjectV3
     */
    readonly projectId: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiGetProjectV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof ProjectApiGetProjectV3
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for moveProjectV3 operation in ProjectApi.
 * @export
 * @interface ProjectApiMoveProjectV3Request
 */
export interface ProjectApiMoveProjectV3Request {
    /**
     * 
     * @type {string}
     * @memberof ProjectApiMoveProjectV3
     */
    readonly projectId: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiMoveProjectV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {TreeNodeNewLocationDto}
     * @memberof ProjectApiMoveProjectV3
     */
    readonly treeNodeNewLocationDto?: TreeNodeNewLocationDto
}

/**
 * Request parameters for restoreProjectV3 operation in ProjectApi.
 * @export
 * @interface ProjectApiRestoreProjectV3Request
 */
export interface ProjectApiRestoreProjectV3Request {
    /**
     * 
     * @type {string}
     * @memberof ProjectApiRestoreProjectV3
     */
    readonly projectId: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiRestoreProjectV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for updateProjectV3 operation in ProjectApi.
 * @export
 * @interface ProjectApiUpdateProjectV3Request
 */
export interface ProjectApiUpdateProjectV3Request {
    /**
     * 
     * @type {string}
     * @memberof ProjectApiUpdateProjectV3
     */
    readonly projectId: string

    /**
     * 
     * @type {string}
     * @memberof ProjectApiUpdateProjectV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {ProjectUpdateDto}
     * @memberof ProjectApiUpdateProjectV3
     */
    readonly projectUpdateDto?: ProjectUpdateDto
}

/**
 * ProjectApi - object-oriented interface
 * @export
 * @class ProjectApi
 * @extends {BaseAPI}
 */
export class ProjectApi extends BaseAPI {
    /**
     * Required permissions: `structure:write`
     * @param {ProjectApiArchiveProjectV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public archiveProjectV3(requestParameters: ProjectApiArchiveProjectV3Request, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).archiveProjectV3(requestParameters.projectId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {ProjectApiCreateProjectV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public createProjectV3(requestParameters: ProjectApiCreateProjectV3Request, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).createProjectV3(requestParameters.tenantId, requestParameters.projectCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {ProjectApiDuplicateProjectV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public duplicateProjectV3(requestParameters: ProjectApiDuplicateProjectV3Request, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).duplicateProjectV3(requestParameters.projectId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {ProjectApiEraseProjectV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public eraseProjectV3(requestParameters: ProjectApiEraseProjectV3Request, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).eraseProjectV3(requestParameters.projectId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`structure:read` OR `device-app:*`]
     * @param {ProjectApiGetAllProjectsV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getAllProjectsV3(requestParameters: ProjectApiGetAllProjectsV3Request, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).getAllProjectsV3(requestParameters.tenantId, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`structure:read` OR `device-app:*`]
     * @param {ProjectApiGetProjectQrImageV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getProjectQrImageV3(requestParameters: ProjectApiGetProjectQrImageV3Request, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).getProjectQrImageV3(requestParameters.projectId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`structure:read` OR `device-app:*`]
     * @param {ProjectApiGetProjectV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getProjectV3(requestParameters: ProjectApiGetProjectV3Request, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).getProjectV3(requestParameters.projectId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {ProjectApiMoveProjectV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public moveProjectV3(requestParameters: ProjectApiMoveProjectV3Request, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).moveProjectV3(requestParameters.projectId, requestParameters.tenantId, requestParameters.treeNodeNewLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {ProjectApiRestoreProjectV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public restoreProjectV3(requestParameters: ProjectApiRestoreProjectV3Request, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).restoreProjectV3(requestParameters.projectId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {ProjectApiUpdateProjectV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public updateProjectV3(requestParameters: ProjectApiUpdateProjectV3Request, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).updateProjectV3(requestParameters.projectId, requestParameters.tenantId, requestParameters.projectUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceWindowApi - axios parameter creator
 * @export
 */
export const ServiceWindowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `structure:write`
         * @param {string} serviceWindowId 
         * @param {string} tenantId 
         * @param {ServiceWindowCompleteDto} serviceWindowCompleteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeServiceWindowV3: async (serviceWindowId: string, tenantId: string, serviceWindowCompleteDto: ServiceWindowCompleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceWindowId' is not null or undefined
            assertParamExists('completeServiceWindowV3', 'serviceWindowId', serviceWindowId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('completeServiceWindowV3', 'tenantId', tenantId)
            // verify required parameter 'serviceWindowCompleteDto' is not null or undefined
            assertParamExists('completeServiceWindowV3', 'serviceWindowCompleteDto', serviceWindowCompleteDto)
            const localVarPath = `/{tenantId}/structure/v3/service-window/{serviceWindowId}/complete`
                .replace(`{${"serviceWindowId"}}`, encodeURIComponent(String(serviceWindowId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serviceWindowCompleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} tenantId 
         * @param {ServiceWindowCreateDto} serviceWindowCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceWindowV3: async (tenantId: string, serviceWindowCreateDto: ServiceWindowCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createServiceWindowV3', 'tenantId', tenantId)
            // verify required parameter 'serviceWindowCreateDto' is not null or undefined
            assertParamExists('createServiceWindowV3', 'serviceWindowCreateDto', serviceWindowCreateDto)
            const localVarPath = `/{tenantId}/structure/v3/service-window`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serviceWindowCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:read`
         * @param {string} tenantId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServiceWindowsV3: async (tenantId: string, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getAllServiceWindowsV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/service-window`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:read`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextServiceWindowByBoltConnectionV3: async (boltConnectionId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('getNextServiceWindowByBoltConnectionV3', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getNextServiceWindowByBoltConnectionV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/service-window/bolt-connection/{boltConnectionId}/next`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} serviceWindowId 
         * @param {string} tenantId 
         * @param {ServiceWindowUpdateDto} serviceWindowUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateServiceWindowV3: async (serviceWindowId: string, tenantId: string, serviceWindowUpdateDto: ServiceWindowUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceWindowId' is not null or undefined
            assertParamExists('updateServiceWindowV3', 'serviceWindowId', serviceWindowId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateServiceWindowV3', 'tenantId', tenantId)
            // verify required parameter 'serviceWindowUpdateDto' is not null or undefined
            assertParamExists('updateServiceWindowV3', 'serviceWindowUpdateDto', serviceWindowUpdateDto)
            const localVarPath = `/{tenantId}/structure/v3/service-window/{serviceWindowId}`
                .replace(`{${"serviceWindowId"}}`, encodeURIComponent(String(serviceWindowId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serviceWindowUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceWindowApi - functional programming interface
 * @export
 */
export const ServiceWindowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceWindowApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `structure:write`
         * @param {string} serviceWindowId 
         * @param {string} tenantId 
         * @param {ServiceWindowCompleteDto} serviceWindowCompleteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeServiceWindowV3(serviceWindowId: string, tenantId: string, serviceWindowCompleteDto: ServiceWindowCompleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceWindowReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeServiceWindowV3(serviceWindowId, tenantId, serviceWindowCompleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceWindowApi.completeServiceWindowV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} tenantId 
         * @param {ServiceWindowCreateDto} serviceWindowCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createServiceWindowV3(tenantId: string, serviceWindowCreateDto: ServiceWindowCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceWindowReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createServiceWindowV3(tenantId, serviceWindowCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceWindowApi.createServiceWindowV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:read`
         * @param {string} tenantId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllServiceWindowsV3(tenantId: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceWindowReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllServiceWindowsV3(tenantId, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceWindowApi.getAllServiceWindowsV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:read`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextServiceWindowByBoltConnectionV3(boltConnectionId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceWindowReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextServiceWindowByBoltConnectionV3(boltConnectionId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceWindowApi.getNextServiceWindowByBoltConnectionV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:write`
         * @param {string} serviceWindowId 
         * @param {string} tenantId 
         * @param {ServiceWindowUpdateDto} serviceWindowUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateServiceWindowV3(serviceWindowId: string, tenantId: string, serviceWindowUpdateDto: ServiceWindowUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceWindowReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateServiceWindowV3(serviceWindowId, tenantId, serviceWindowUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceWindowApi.updateServiceWindowV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceWindowApi - factory interface
 * @export
 */
export const ServiceWindowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceWindowApiFp(configuration)
    return {
        /**
         * Required permissions: `structure:write`
         * @param {ServiceWindowApiCompleteServiceWindowV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeServiceWindowV3(requestParameters: ServiceWindowApiCompleteServiceWindowV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ServiceWindowReadDto> {
            return localVarFp.completeServiceWindowV3(requestParameters.serviceWindowId, requestParameters.tenantId, requestParameters.serviceWindowCompleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {ServiceWindowApiCreateServiceWindowV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceWindowV3(requestParameters: ServiceWindowApiCreateServiceWindowV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ServiceWindowReadDto> {
            return localVarFp.createServiceWindowV3(requestParameters.tenantId, requestParameters.serviceWindowCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:read`
         * @param {ServiceWindowApiGetAllServiceWindowsV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServiceWindowsV3(requestParameters: ServiceWindowApiGetAllServiceWindowsV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ServiceWindowReadDtoPageDto> {
            return localVarFp.getAllServiceWindowsV3(requestParameters.tenantId, requestParameters.skip, requestParameters.take, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:read`
         * @param {ServiceWindowApiGetNextServiceWindowByBoltConnectionV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextServiceWindowByBoltConnectionV3(requestParameters: ServiceWindowApiGetNextServiceWindowByBoltConnectionV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ServiceWindowReadDto> {
            return localVarFp.getNextServiceWindowByBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:write`
         * @param {ServiceWindowApiUpdateServiceWindowV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateServiceWindowV3(requestParameters: ServiceWindowApiUpdateServiceWindowV3Request, options?: RawAxiosRequestConfig): AxiosPromise<ServiceWindowReadDto> {
            return localVarFp.updateServiceWindowV3(requestParameters.serviceWindowId, requestParameters.tenantId, requestParameters.serviceWindowUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for completeServiceWindowV3 operation in ServiceWindowApi.
 * @export
 * @interface ServiceWindowApiCompleteServiceWindowV3Request
 */
export interface ServiceWindowApiCompleteServiceWindowV3Request {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowApiCompleteServiceWindowV3
     */
    readonly serviceWindowId: string

    /**
     * 
     * @type {string}
     * @memberof ServiceWindowApiCompleteServiceWindowV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {ServiceWindowCompleteDto}
     * @memberof ServiceWindowApiCompleteServiceWindowV3
     */
    readonly serviceWindowCompleteDto: ServiceWindowCompleteDto
}

/**
 * Request parameters for createServiceWindowV3 operation in ServiceWindowApi.
 * @export
 * @interface ServiceWindowApiCreateServiceWindowV3Request
 */
export interface ServiceWindowApiCreateServiceWindowV3Request {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowApiCreateServiceWindowV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {ServiceWindowCreateDto}
     * @memberof ServiceWindowApiCreateServiceWindowV3
     */
    readonly serviceWindowCreateDto: ServiceWindowCreateDto
}

/**
 * Request parameters for getAllServiceWindowsV3 operation in ServiceWindowApi.
 * @export
 * @interface ServiceWindowApiGetAllServiceWindowsV3Request
 */
export interface ServiceWindowApiGetAllServiceWindowsV3Request {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowApiGetAllServiceWindowsV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {number}
     * @memberof ServiceWindowApiGetAllServiceWindowsV3
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof ServiceWindowApiGetAllServiceWindowsV3
     */
    readonly take?: number
}

/**
 * Request parameters for getNextServiceWindowByBoltConnectionV3 operation in ServiceWindowApi.
 * @export
 * @interface ServiceWindowApiGetNextServiceWindowByBoltConnectionV3Request
 */
export interface ServiceWindowApiGetNextServiceWindowByBoltConnectionV3Request {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowApiGetNextServiceWindowByBoltConnectionV3
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof ServiceWindowApiGetNextServiceWindowByBoltConnectionV3
     */
    readonly tenantId: string
}

/**
 * Request parameters for updateServiceWindowV3 operation in ServiceWindowApi.
 * @export
 * @interface ServiceWindowApiUpdateServiceWindowV3Request
 */
export interface ServiceWindowApiUpdateServiceWindowV3Request {
    /**
     * 
     * @type {string}
     * @memberof ServiceWindowApiUpdateServiceWindowV3
     */
    readonly serviceWindowId: string

    /**
     * 
     * @type {string}
     * @memberof ServiceWindowApiUpdateServiceWindowV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {ServiceWindowUpdateDto}
     * @memberof ServiceWindowApiUpdateServiceWindowV3
     */
    readonly serviceWindowUpdateDto: ServiceWindowUpdateDto
}

/**
 * ServiceWindowApi - object-oriented interface
 * @export
 * @class ServiceWindowApi
 * @extends {BaseAPI}
 */
export class ServiceWindowApi extends BaseAPI {
    /**
     * Required permissions: `structure:write`
     * @param {ServiceWindowApiCompleteServiceWindowV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceWindowApi
     */
    public completeServiceWindowV3(requestParameters: ServiceWindowApiCompleteServiceWindowV3Request, options?: RawAxiosRequestConfig) {
        return ServiceWindowApiFp(this.configuration).completeServiceWindowV3(requestParameters.serviceWindowId, requestParameters.tenantId, requestParameters.serviceWindowCompleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {ServiceWindowApiCreateServiceWindowV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceWindowApi
     */
    public createServiceWindowV3(requestParameters: ServiceWindowApiCreateServiceWindowV3Request, options?: RawAxiosRequestConfig) {
        return ServiceWindowApiFp(this.configuration).createServiceWindowV3(requestParameters.tenantId, requestParameters.serviceWindowCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:read`
     * @param {ServiceWindowApiGetAllServiceWindowsV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceWindowApi
     */
    public getAllServiceWindowsV3(requestParameters: ServiceWindowApiGetAllServiceWindowsV3Request, options?: RawAxiosRequestConfig) {
        return ServiceWindowApiFp(this.configuration).getAllServiceWindowsV3(requestParameters.tenantId, requestParameters.skip, requestParameters.take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:read`
     * @param {ServiceWindowApiGetNextServiceWindowByBoltConnectionV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceWindowApi
     */
    public getNextServiceWindowByBoltConnectionV3(requestParameters: ServiceWindowApiGetNextServiceWindowByBoltConnectionV3Request, options?: RawAxiosRequestConfig) {
        return ServiceWindowApiFp(this.configuration).getNextServiceWindowByBoltConnectionV3(requestParameters.boltConnectionId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:write`
     * @param {ServiceWindowApiUpdateServiceWindowV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceWindowApi
     */
    public updateServiceWindowV3(requestParameters: ServiceWindowApiUpdateServiceWindowV3Request, options?: RawAxiosRequestConfig) {
        return ServiceWindowApiFp(this.configuration).updateServiceWindowV3(requestParameters.serviceWindowId, requestParameters.tenantId, requestParameters.serviceWindowUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TreeNodeApi - axios parameter creator
 * @export
 */
export const TreeNodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTreesV3: async (tenantId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getAllTreesV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/tree-node`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} treeNodeId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubTreeV3: async (treeNodeId: string, tenantId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeNodeId' is not null or undefined
            assertParamExists('getSubTreeV3', 'treeNodeId', treeNodeId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getSubTreeV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/tree-node/{treeNodeId}/sub-tree`
                .replace(`{${"treeNodeId"}}`, encodeURIComponent(String(treeNodeId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} rootId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreeV3: async (rootId: string, tenantId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rootId' is not null or undefined
            assertParamExists('getTreeV3', 'rootId', rootId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTreeV3', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/structure/v3/tree-node/{rootId}`
                .replace(`{${"rootId"}}`, encodeURIComponent(String(rootId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TreeNodeApi - functional programming interface
 * @export
 */
export const TreeNodeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TreeNodeApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTreesV3(tenantId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TreeNodeReadDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTreesV3(tenantId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreeNodeApi.getAllTreesV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} treeNodeId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubTreeV3(treeNodeId: string, tenantId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TreeNodeReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubTreeV3(treeNodeId, tenantId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreeNodeApi.getSubTreeV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {string} rootId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreeV3(rootId: string, tenantId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TreeNodeReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreeV3(rootId, tenantId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreeNodeApi.getTreeV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TreeNodeApi - factory interface
 * @export
 */
export const TreeNodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TreeNodeApiFp(configuration)
    return {
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {TreeNodeApiGetAllTreesV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTreesV3(requestParameters: TreeNodeApiGetAllTreesV3Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<TreeNodeReadDto>> {
            return localVarFp.getAllTreesV3(requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {TreeNodeApiGetSubTreeV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubTreeV3(requestParameters: TreeNodeApiGetSubTreeV3Request, options?: RawAxiosRequestConfig): AxiosPromise<TreeNodeReadDto> {
            return localVarFp.getSubTreeV3(requestParameters.treeNodeId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`structure:read` OR `device-app:*`]
         * @param {TreeNodeApiGetTreeV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreeV3(requestParameters: TreeNodeApiGetTreeV3Request, options?: RawAxiosRequestConfig): AxiosPromise<TreeNodeReadDto> {
            return localVarFp.getTreeV3(requestParameters.rootId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAllTreesV3 operation in TreeNodeApi.
 * @export
 * @interface TreeNodeApiGetAllTreesV3Request
 */
export interface TreeNodeApiGetAllTreesV3Request {
    /**
     * 
     * @type {string}
     * @memberof TreeNodeApiGetAllTreesV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof TreeNodeApiGetAllTreesV3
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for getSubTreeV3 operation in TreeNodeApi.
 * @export
 * @interface TreeNodeApiGetSubTreeV3Request
 */
export interface TreeNodeApiGetSubTreeV3Request {
    /**
     * 
     * @type {string}
     * @memberof TreeNodeApiGetSubTreeV3
     */
    readonly treeNodeId: string

    /**
     * 
     * @type {string}
     * @memberof TreeNodeApiGetSubTreeV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof TreeNodeApiGetSubTreeV3
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for getTreeV3 operation in TreeNodeApi.
 * @export
 * @interface TreeNodeApiGetTreeV3Request
 */
export interface TreeNodeApiGetTreeV3Request {
    /**
     * 
     * @type {string}
     * @memberof TreeNodeApiGetTreeV3
     */
    readonly rootId: string

    /**
     * 
     * @type {string}
     * @memberof TreeNodeApiGetTreeV3
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof TreeNodeApiGetTreeV3
     */
    readonly includeArchived?: boolean
}

/**
 * TreeNodeApi - object-oriented interface
 * @export
 * @class TreeNodeApi
 * @extends {BaseAPI}
 */
export class TreeNodeApi extends BaseAPI {
    /**
     * Required permissions: [`structure:read` OR `device-app:*`]
     * @param {TreeNodeApiGetAllTreesV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreeNodeApi
     */
    public getAllTreesV3(requestParameters: TreeNodeApiGetAllTreesV3Request, options?: RawAxiosRequestConfig) {
        return TreeNodeApiFp(this.configuration).getAllTreesV3(requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`structure:read` OR `device-app:*`]
     * @param {TreeNodeApiGetSubTreeV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreeNodeApi
     */
    public getSubTreeV3(requestParameters: TreeNodeApiGetSubTreeV3Request, options?: RawAxiosRequestConfig) {
        return TreeNodeApiFp(this.configuration).getSubTreeV3(requestParameters.treeNodeId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`structure:read` OR `device-app:*`]
     * @param {TreeNodeApiGetTreeV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreeNodeApi
     */
    public getTreeV3(requestParameters: TreeNodeApiGetTreeV3Request, options?: RawAxiosRequestConfig) {
        return TreeNodeApiFp(this.configuration).getTreeV3(requestParameters.rootId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }
}



